export type Volume = {
  number: number
  dot: string
  group: string
  title: string
  subtitle: string
  tags: string[]
}

export const volumes: Volume[] = [
  {
    number: 1,
    dot: '#22C55E',
    group: 'Niños Sub-10',
    title: 'Niños Sub-10 Iniciación A',
    subtitle: 'Primer contacto con la raqueta',
    tags: ['Coordinación', 'Mini-Tenis', 'Juegos Divertidos', 'Puntuación Adaptada'],
  },
  {
    number: 2,
    dot: '#22C55E',
    group: 'Niños Sub-10',
    title: 'Niños Sub-10 Iniciación B',
    subtitle: 'Dirección y primeros puntos',
    tags: ['Cruzados', 'Reglas Adaptadas', 'Primeros Puntos'],
  },
  {
    number: 3,
    dot: '#EAB308',
    group: 'Niños',
    title: 'Niños Principiantes — Sin Experiencia',
    subtitle: 'Construyendo las primeras bases técnicas',
    tags: ['Empuñadura', 'Postura', 'Derecha', 'Revés Básico'],
  },
  {
    number: 4,
    dot: '#EAB308',
    group: 'Niños',
    title: 'Niños Intermedio 1',
    subtitle: 'Constancia y primeras tácticas',
    tags: ['Control de Dirección', 'Profundidad', 'Primeros Patrones'],
  },
  {
    number: 5,
    dot: '#F97316',
    group: 'Niños',
    title: 'Niños Intermedio 2',
    subtitle: 'Patrones y juego de dobles',
    tags: ['Patrón Cruzado–Paralelo', 'Intención en el Saque', 'Introducción a Dobles'],
  },
  {
    number: 6,
    dot: '#F97316',
    group: 'Niños',
    title: 'Niños Avanzado',
    subtitle: 'Preparación para la competencia',
    tags: ['Juego en Red', 'Táctica Avanzada', 'Listos para Torneos'],
  },
  {
    number: 7,
    dot: '#EF4444',
    group: 'Adultos y Adolescentes',
    title: 'Adultos y Adolescentes Principiantes — Sin Experiencia',
    subtitle: 'Nunca han tomado una raqueta',
    tags: ['Primer Peloteo', 'Golpes de Fondo', 'Primeros Puntos', 'Reglas de la Cancha'],
  },
  {
    number: 8,
    dot: '#EF4444',
    group: 'Adultos y Adolescentes',
    title: 'Adultos y Adolescentes Intermedio 1',
    subtitle: 'Construyendo constancia y dirección',
    tags: ['Control del Cruzado', 'Profundidad', 'Recuperación a la T'],
  },
  {
    number: 9,
    dot: '#A855F7',
    group: 'Adultos y Adolescentes',
    title: 'Adultos y Adolescentes Intermedio 2',
    subtitle: 'Topspin y sistemas tácticos',
    tags: ['Topspin Pesado', 'Juego por Patrones', 'Introducción al Juego Mental'],
  },
  {
    number: 10,
    dot: '#A855F7',
    group: 'Adultos y Adolescentes',
    title: 'Adultos y Adolescentes Avanzado',
    subtitle: 'Alto rendimiento nivel club',
    tags: ['Armas de Juego', 'Sistema de Golpe Ganador', 'Saque + 1', 'Dominio en la Red'],
  },
  {
    number: 11,
    dot: '#D7F84A',
    group: 'Casos Especiales',
    title: 'Casos Especiales: Jugadores Senior',
    subtitle: 'Tenis adaptado a cuerpos maduros',
    tags: ['Movilidad', 'Equilibrio', 'Ejercicios de Bajo Impacto', 'Enfoque en el Disfrute'],
  },
  {
    number: 12,
    dot: '#D7F84A',
    group: 'Casos Especiales',
    title: 'Casos Especiales: Vuelta tras Lesión',
    subtitle: 'Protocolos seguros para la recuperación',
    tags: ['Codo', 'Rodilla', 'Hombro', 'Planes de Retorno para Espalda'],
  },
]

export const volumeIncludes: string[] = [
  'Planes de sesión completos listos para usar en cancha',
  'Ejercicios profesionales con diagramas de cancha',
  'Progresión clara nivel por nivel',
  'Objetivos de sesión predefinidos',
  'Fichas de evaluación de alumnos',
  'Adaptaciones para clases grupales',
  'Variaciones según el nivel',
  'Optimizado para móvil e impresión A4',
]

export const coverage: string[] = [
  'Niños Sub-10',
  'Niños Principiantes',
  'Niños Intermedio',
  'Niños Avanzado',
  'Adultos Principiantes',
  'Adultos Intermedio',
  'Adultos Avanzado',
  'Jugadores Senior',
  'Vuelta tras Lesión',
]
